/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { LightInput, PrimaryButton, FieldWrapper, GeneralFormError } from 'ui';
import { FluidPreloader } from 'components/core/preloader';
import { Form, Field } from 'formik';
import Icon from 'components/core/icon';

import FooterShared from './layout/footer';
import HeaderShared from './layout/header';
import SubTitleShared from './layout/subtitle';
import s from './styles.module.scss';

const RecoverPassword = ({ className = null, children = null, isSubmitting, ...props }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(s.sharedForm, className)}>
      <HeaderShared>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <SubTitleShared>{t('enter_new_password')}</SubTitleShared>
      <Form>
        <Field
          id="password"
          name="password"
          placeholder={t('password')}
          secureTextEntry
          component={FieldWrapper}
          inputComponent={LightInput}
          className={s.sharedFormField}
        />
        <Field
          id="confirm_password"
          name="confirm_password"
          placeholder={t('confirm_new_password')}
          secureTextEntry
          component={FieldWrapper}
          inputComponent={LightInput}
          className={s.sharedFormField}
        />
        <PrimaryButton
          type="submit"
          className={s.sharedFormSubmit}
          onClick={props.handleSubmit}
          isDisabled={isSubmitting}
        >
          {isSubmitting ? <FluidPreloader light /> : <>{t('recover_password')}</>}
        </PrimaryButton>
        <GeneralFormError error={props.errors.detail} />
      </Form>
      <FooterShared className="singleLink">
        <Link to="/#" className={s.sharedFormFooterLink}>
          <Icon className={s.sharedFormFooterLinkIcon} icon={Icon.icons.arrowLeft} />
          {t('back')}
        </Link>
        <Link to="/contact-us" className={s.sharedFormFooterLink}>
          {t('contact_us')}
        </Link>
      </FooterShared>
    </div>
  );
};

RecoverPassword.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default RecoverPassword;
